import Image from 'next/image';
import { PocketbookIcon } from 'mode-shared/components';

export const AccountIcon = ({ walletIconSrc, size = 24 }: { walletIconSrc?: string; size?: number }) => {
  return walletIconSrc ? (
    <Image className="shrink-0 rounded-md" src={walletIconSrc?.trim()} alt="Wallet Icon" width={size} height={size} />
  ) : (
    <div className="shrink-0 rounded-full bg-yellow-500 flex items-center justify-center p-1">
      <PocketbookIcon className="text-neutral-900" />
    </div>
  );
};
